import home from './home'

function index() {
  home()
}

export default index
